import {
  Box,
  Grid,
  Typography,
  Avatar,
  Stack,
  Chip,
  Button,
  Divider,
  Breadcrumbs,
  Link,
  Rating,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CardMedia,
  CircularProgress,
  TextField,
  InputAdornment,
  Tabs,
  Tab,
  Pagination,
  PaginationItem,
  Skeleton,
  Modal,
  Paper,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate } from "react-router-dom";
import OceshaLogo from "../../../assets/ocesha_images/ocesha_logo.png";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { ReactComponent as VerifiedTick } from "../../../assets/podcast_monster/verified-tick.svg";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import ContentPasteOutlinedIcon from "@mui/icons-material/ContentPasteOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import certificate from "../../../assets/podcast_monster/Certificates.png";
import { ReactComponent as FavIcon } from "../../../assets/podcast_monster/favorite_ico.svg";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import { ReactComponent as CloudDownload } from "../../../assets/podcast_monster/cloud_download_ico.svg";
import { ReactComponent as MobileIco } from "../../../assets/podcast_monster/mobile_ico.svg";
import { ReactComponent as LinkIco } from "../../../assets/podcast_monster/link_ico.svg";
import { ReactComponent as MedalIco } from "../../../assets/podcast_monster/medal_ico.svg";
import { isMobile } from "react-device-detect";
import { useEffect, useState, useRef } from "react";
// import Header from "../../auth/Header";
import SearchIcon from "@mui/icons-material/Search";
import VerifiedIcon from "@mui/icons-material/Verified";
import axios from "axios";
import Headernew from "../../auth/headernew";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

// ── Light theme tokens matching MyDashboard ──
const interFont = "'Inter', sans-serif";
const cardBg = "#161b22";
const cardBorder = "#21262d";
const pageBg = "transparent";
const primary = "#3b82f6";
const primaryLight = "#60a5fa";

const filters = [
  "All",
  "Business",
  "Fitness",
  "Marketing",
  "Podcasting",
  "Personal Growth",
];

export default function CreatorDirectory() {
  const navigate = useNavigate();
  const supportUserid = process.env.REACT_APP_SUPPORT_USER_ID || "";
  const loggedIn = localStorage.getItem("logged_in");
  const location = useLocation();

  // const partnerName = location.pathname.split("/").filter(Boolean).pop();
  const partnerName = location.pathname.endsWith("/GBA") ? "GBA" : "";


  const [active, setActive] = useState(filters[0]);
  const apiURL = process.env.REACT_APP_SERVER_ENDPOINT || "";

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [totalPages, setTotalPages] = useState(1);
  const [creators, setCreators] = useState<any[]>([]);
  const isStrictModeSecondCall = useRef(false);
  const [loading, setLoading] = useState(false);
  const [totalReviewsMap, setTotalReviewsMap] = useState<any>({});
  const [loginPopup, setLoginPopup] = useState(false);

  const shouldSendPartner =
    partnerName /* === "GBA" */ ||
    localStorage.getItem("partner_name") /* === "GPA" */;

  const apiPartnerName = shouldSendPartner /* ? "GPA" : "" */;

  // ── ALL API / LOGIC FUNCTIONS UNTOUCHED ──

  const GetCreatorDirectories = async () => {
    try {
      setLoading(true);
      // const partnerName = localStorage.getItem("partner_name");
      const res = await axios.get(`${apiURL}/api/admin/creator-directory`, {
        params: { search, category: active, page, limit, ...(apiPartnerName && { partner_name: apiPartnerName }) },
      });
      /* ...(partnerName === "GPA" && { partner_name: "GPA" }) */
      const rawList: any[] = res.data?.data || [];
      setTotalPages(res.data?.pagination?.total_pages || 1);

      if (rawList.length > 0) {
        console.log("=== CREATOR RAW FIELDS ===", rawList[0]);
      }

      // ── Enrich each creator with full user-profile data ──
      const enriched = await Promise.all(
        rawList.map(async (c: any) => {
          const userId = c._id || c.user_id || c.mentor_id || c.id || "";
          const email = c.user_email || c.email || c.mentor_email || "";

          try {
            let profileData: any = {};

            // Primary: POST /api/auth/getUserDetailByID  (works with MongoDB _id)
            if (userId) {
              try {
                const r = await axios.post(
                  `${apiURL}/api/auth/getUserDetailByID`,
                  null,
                  { params: { id: userId } }
                );
                console.log("getUserDetailByID raw =>", userId, r.data);
                const raw = r.data;
                profileData =
                  raw?.data ?? raw?.user ?? raw?.result ??
                  (Array.isArray(raw) ? raw[0] : null) ??
                  (typeof raw === "object" && raw?.status !== undefined
                    ? Object.fromEntries(Object.entries(raw).filter(([k]) => k !== "status" && k !== "message"))
                    : raw) ?? {};
              } catch (e) {
                console.log("getUserDetailByID failed, trying email =>", e);
              }
            }

            // Fallback: POST /api/auth/getUserDetailByEmailID  (works with email)
            if (!profileData._id && email) {
              try {
                const r = await axios.post(
                  `${apiURL}/api/auth/getUserDetailByEmailID`,
                  null,
                  { params: { email, filter: "", start_date: "", end_date: "" } }
                );
                console.log("getUserDetailByEmailID raw =>", email, r.data);
                const raw = r.data;
                profileData =
                  raw?.data ?? raw?.user ?? raw?.result ??
                  (Array.isArray(raw) ? raw[0] : null) ??
                  (typeof raw === "object" && raw?.status !== undefined
                    ? Object.fromEntries(Object.entries(raw).filter(([k]) => k !== "status" && k !== "message"))
                    : raw) ?? {};
              } catch (e) {
                console.log("getUserDetailByEmailID also failed =>", e);
              }
            }

            console.log("Final profileData =>", profileData);

            // skills — Array in MongoDB
            let skills: string[] = [];
            const rawSkills = profileData.skills || profileData.tools_technologies || c.skills || [];
            if (Array.isArray(rawSkills)) skills = rawSkills.filter(Boolean);
            else if (typeof rawSkills === "string" && rawSkills.trim())
              skills = rawSkills.split(",").map((s: string) => s.trim()).filter(Boolean);

            // reviews
            const resolvedId = profileData._id || userId;
            let reviewCount = 0;
            if (resolvedId) {
              try {
                const revRes = await axios.get(`${apiURL}/api/student/reviews/mentor/${resolvedId}`);
                reviewCount = revRes.data?.total_reviews ?? 0;
              } catch { /* silent */ }
            }

            return {
              ...c,
              ...profileData,
              _id: profileData._id || userId,
              user_id: profileData._id || userId,
              mentor_id: profileData._id || userId,
              user_email: profileData.email || email,
              email: profileData.email || email,
              name: profileData.name || profileData.first_name || c.name,
              bio: profileData.bio || profileData.experience_summary || c.bio || "",
              profile_image: profileData.user_image || profileData.profile_image || profileData.avatar || c.profile_image || "",
              skills,
              total_learners: profileData.total_learners ?? profileData.learners_count ?? c.total_learners ?? 0,
              _reviews: reviewCount,
            };
          } catch (err) {
            console.log("Enrichment failed =>", err);
            let skills: string[] = [];
            const rawSkills = c.skills || c.tools_technologies || [];
            if (Array.isArray(rawSkills)) skills = rawSkills.filter(Boolean);
            else if (typeof rawSkills === "string")
              skills = rawSkills.split(",").map((s: string) => s.trim()).filter(Boolean);
            return {
              ...c,
              skills,
              profile_image: c.user_image || c.profile_image || "",
              bio: c.bio || c.experience_summary || "",
            };
          }
        })
      );

      setCreators(enriched);
    } catch (error: any) {
      console.log("Error fetching creator directories=>", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetCreatorDirectories();
  }, [search, active, page]);

  const GetMentorTotalReviews = async (mentor_id: string) => {
    try {
      const res = await axios.get(
        `${apiURL}/api/student/reviews/mentor/${mentor_id}`
      );
      return res.data?.total_reviews || 0;
    } catch (error) {
      console.log("Error fetching mentor reviews =>", error);
      return 0;
    }
  };

  useEffect(() => {
    const loadAllReviews = async () => {
      try {
        const map: any = {};
        await Promise.all(
          creators.map(async (c: any) => {
            const mentorId = c.mentor_id || c.user_id || c._id || c.id;
            if (!mentorId) {
              console.log(" Missing mentorId for:", c);
              return;
            }
            try {
              const res = await axios.get(
                `${apiURL}/api/student/reviews/mentor/${mentorId}`
              );
              map[mentorId] = res.data?.total_reviews ?? 0;
            } catch (err) {
              console.log("API ERROR for", mentorId);
              map[mentorId] = 0;
            }
          })
        );
        setTotalReviewsMap(map);
      } catch (error) {
        console.log("Error loading reviews =>", error);
      }
    };
    if (creators.length > 0) {
      loadAllReviews();
    }
  }, [creators]);


  // ── RENDER ──
  return (
    <>
      <Headernew />

      <Box
        className="overlay-container"
        sx={{ pr: 10, pl: 10, minHeight: "100vh", background: pageBg }}
      >
        <Box
          sx={{
            minHeight: "100vh",
            color: "#e5e7eb",
            px: { xs: 2, md: 6 },
            pt: 4,
            pb: 6,
            maxWidth: 1100,
            mx: "auto",
          }}
        >
          {/* Back Button */}
          <Button
            startIcon={<NavigateBeforeIcon />}
            onClick={() => navigate(-1)}
            sx={{
              fontFamily: interFont,
              fontWeight: 500,
              fontSize: 13,
              textTransform: "none",
              color: "#9ca3af",
              mb: 2,
              px: 0,
              minWidth: "auto",
              "&:hover": { color: primaryLight, background: "transparent" },
            }}
          >
            Back
          </Button>

          {/* Page title — matches MyDashboard style */}
          <Typography
            fontFamily={interFont}
            fontSize={22}
            fontWeight={600}
            letterSpacing="-0.02em"
            color={primaryLight}
          >
            Creator Directory
          </Typography>
          <Typography
            fontFamily={interFont}
            fontSize={13}
            color="#9ca3af"
            mb={3}
          >
            Discover instructors and creators to learn from
          </Typography>

          {/* Search + Filters */}
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "stretch", md: "center" }}
            mb={4}
            spacing={3}
          >
            {/* Search */}
            <Box>
              <Typography
                fontFamily={interFont}
                fontSize={13}
                mb={0.5}
                color="#9ca3af"
                fontWeight={500}
              >
                Search
              </Typography>
              <TextField
                placeholder="Search by name"
                size="small"
                sx={{
                  width: 280,
                  background: "#161b22",
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "& fieldset": { borderColor: cardBorder },
                    "&:hover fieldset": { borderColor: primaryLight },
                    "&.Mui-focused fieldset": { borderColor: primary },
                  },
                  "& input": {
                    color: "#e5e7eb",
                    fontFamily: interFont,
                    fontSize: 13,
                    "&::placeholder": {
                      color: "#6b7280",
                      opacity: 1,
                    },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon sx={{ color: "#6b7280", fontSize: 18 }} />
                    </InputAdornment>
                  ),
                }}
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
              />
            </Box>

            {/* Filters */}
            <Box>
              <Typography
                fontFamily={interFont}
                fontSize={13}
                mb={0.5}
                color="#9ca3af"
                fontWeight={500}
              >
                Filters
              </Typography>

              <Box
                sx={{
                  background: "#21262d",
                  borderRadius: "8px",
                  p: "4px",
                  display: "block",
                  maxWidth: "100%",
                }}
              >
                <Tabs
                  value={filters.indexOf(active)}
                  onChange={(_: any, newValue: any) => {
                    setActive(filters[newValue]);
                    setPage(1);
                  }}
                  TabIndicatorProps={{ style: { display: "none" } }}
                  variant="scrollable"
                  scrollButtons={false}
                  sx={{
                    minHeight: "unset",
                    maxWidth: "100%",
                    "& .MuiTabs-scroller": { overflowX: "auto" },
                    "& .MuiTabs-flexContainer": {
                      gap: "4px",
                      flexWrap: "nowrap",
                    },
                  }}
                >
                  {filters.map((f) => (
                    <Tab
                      key={f}
                      label={f}
                      disableRipple
                      sx={{
                        minHeight: "unset",
                        textTransform: "none",
                        fontFamily: interFont,
                        fontSize: 13,
                        color: "#9ca3af",
                        borderRadius: "6px",
                        px: 1.5,
                        py: 0.5,
                        "&.Mui-selected": {
                          background: "#161b22",
                          border: "1px solid #30363d",
                          color: "#e5e7eb",
                          fontWeight: 600,
                        },
                      }}
                    />
                  ))}
                </Tabs>
              </Box>
            </Box>
          </Stack>

          {/* Cards */}
          <Grid container spacing={3}>
            {/* Skeleton Loader */}
            {loading &&
              Array.from(new Array(6)).map((_, i) => (
                <Grid item xs={12} md={4} key={i}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: cardBg,
                      border: `1px solid ${cardBorder}`,
                      borderRadius: "12px",
                      p: 3,
                    }}
                  >
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Skeleton variant="circular" width={56} height={56} />
                      <Stack spacing={1}>
                        <Skeleton width={120} height={20} />
                        <Skeleton width={80} height={15} />
                      </Stack>
                    </Stack>
                    <Skeleton sx={{ mt: 2 }} height={40} />
                    <Skeleton width="60%" height={20} />
                    <Stack direction="row" spacing={1} mt={1}>
                      <Skeleton width={60} height={25} />
                      <Skeleton width={60} height={25} />
                      <Skeleton width={60} height={25} />
                    </Stack>
                    <Stack direction="row" spacing={3} mt={2}>
                      <Skeleton width={80} height={25} />
                      <Skeleton width={80} height={25} />
                    </Stack>
                    <Stack direction="row" spacing={1} mt={2}>
                      <Skeleton height={35} width="100%" />
                      <Skeleton height={35} width="100%" />
                    </Stack>
                  </Paper>
                </Grid>
              ))}

            {/* No Data */}
            {!loading && creators.length === 0 && (
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 200,
                    color: "#6b7280",
                    fontFamily: interFont,
                    fontSize: 15,
                  }}
                >
                  No Data Found
                </Box>
              </Grid>
            )}

            {!loading &&
              creators.length > 0 &&
              creators.map((c: any, i: any) => (
                <Grid item xs={12} md={4} key={i}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: cardBg,
                      border: `1px solid ${cardBorder}`,
                      borderRadius: "12px",
                      p: "20px 20px 16px 20px",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      transition: "box-shadow 0.2s ease, border-color 0.2s ease",
                      "&:hover": {
                        boxShadow: "0 4px 20px rgba(59,130,246,0.15)",
                        borderColor: "#3b82f6",
                      },
                    }}
                  >
                    {/* Avatar + name */}
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Avatar
                        src={c.profile_image}
                        sx={{
                          width: 72,
                          height: 72,
                          flexShrink: 0,
                          borderRadius: "36px",
                          border: "2px solid #30363d",
                        }}
                      />

                      <Stack spacing={0.5}>
                        <Typography
                          fontFamily={interFont}
                          fontWeight={700}
                          fontSize={15}
                          color="#e5e7eb"
                          letterSpacing="-0.01em"
                        >
                          {c.name}
                        </Typography>

                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "5px",
                            background: "rgba(59,130,246,0.1)",
                            border: "1px solid rgba(59,130,246,0.3)",
                            px: 1,
                            py: "2px",
                            borderRadius: "6px",
                            width: "fit-content",
                          }}
                        >
                          <VerifiedTick style={{ width: 12, height: 12 }} />
                          <Typography
                            fontFamily={interFont}
                            fontSize={11}
                            fontWeight={600}
                            color={primary}
                            letterSpacing="0.04em"
                          >
                            INSTRUCTOR
                          </Typography>
                        </Box>
                      </Stack>
                    </Stack>

                    {/* Bio */}
                    <Typography
                      fontFamily={interFont}
                      fontSize={13}
                      mt={2}
                      color="#9ca3af"
                      lineHeight={1.65}
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        height: 64,
                        flexShrink: 0,
                      }}
                    >
                      {c.bio || "No bio available."}
                    </Typography>

                    {/* Skills */}
                    <Typography
                      fontFamily={interFont}
                      fontSize={12}
                      mt={2}
                      mb={0.75}
                      color="#6b7280"
                      fontWeight={600}
                      letterSpacing="0.03em"
                      textTransform="uppercase"
                    >
                      Skills
                    </Typography>

                    <Stack
                      direction="row"
                      flexWrap="wrap"
                      sx={{ gap: "6px", minHeight: 56, alignContent: "flex-start" }}
                      mb={2.5}
                    >
                      {c.skills && c.skills.length > 0
                        ? c.skills.slice(0, 4).map((s: any) => (
                          <Chip
                            key={s}
                            label={s}
                            size="small"
                            sx={{
                              background: "#0d1117",
                              color: "#d1d5db",
                              borderRadius: "999px",
                              fontFamily: interFont,
                              fontSize: 11,
                              fontWeight: 500,
                              border: "1px solid #30363d",
                            }}
                          />
                        ))
                        : (
                          <Typography fontFamily={interFont} fontSize={13} color="#6b7280">
                            NA
                          </Typography>
                        )}
                    </Stack>

                    {/* Stats */}
                    <Stack direction="row" spacing={4} mb={2.5}>
                      <Stack spacing={0.25}>
                        <Typography
                          fontFamily={interFont}
                          fontSize={12}
                          color="#6b7280"
                          fontWeight={500}
                        >
                          Total learners
                        </Typography>
                        <Typography
                          fontFamily={interFont}
                          fontWeight={700}
                          fontSize={20}
                          color="#e5e7eb"
                          letterSpacing="-0.02em"
                          lineHeight={1.1}
                        >
                          {c.total_learners ?? 0}
                        </Typography>
                      </Stack>

                      <Stack spacing={0.25}>
                        <Typography
                          fontFamily={interFont}
                          fontSize={12}
                          color="#6b7280"
                          fontWeight={500}
                        >
                          Reviews
                        </Typography>
                        <Typography
                          fontFamily={interFont}
                          fontWeight={700}
                          fontSize={20}
                          color="#e5e7eb"
                          letterSpacing="-0.02em"
                          lineHeight={1.1}
                        >
                          {totalReviewsMap[
                            c.mentor_id || c.user_id || c._id || c.id
                          ] || c._reviews || 0}
                        </Typography>
                      </Stack>
                    </Stack>

                    <Divider sx={{ borderColor: "#21262d" }} />

                    {/* Buttons */}
                    <Stack direction="row" spacing={1.5} mt={2}>
                      <Button
                        fullWidth
                        variant="outlined"
                        sx={{
                          fontFamily: interFont,
                          fontWeight: 600,
                          fontSize: 13,
                          color: "#d1d5db",
                          borderColor: "#30363d",
                          textTransform: "none",
                          borderRadius: "8px",
                          py: 0.9,
                          "&:hover": {
                            borderColor: primary,
                            color: primary,
                            background: "rgba(59,130,246,0.1)",
                          },
                        }}
                        onClick={() => {
                          const isLoggedIn =
                            localStorage.getItem("logged_in") === "true";
                          if (isLoggedIn) {
                            const mentorId =
                              c.mentor_id || c.user_id || c._id || c.id;
                            if (mentorId) {
                              localStorage.setItem("mentor_id", mentorId);
                            }
                            localStorage.setItem("activeItem", "course");
                            const email = encodeURIComponent(c.user_email || c.email || "");
                            window.open(`/codegenie/instructor-profile?mentor_id=${email}`, "_blank");
                          } else {
                            localStorage.setItem(
                              "redirectAfterLogin",
                              "creator_directory"
                            );
                            setLoginPopup(true);
                          }
                        }}
                      >
                        Visit Profile
                      </Button>

                      <Button
                        fullWidth
                        variant="contained"
                        disableElevation
                        sx={{
                          fontFamily: interFont,
                          fontWeight: 600,
                          fontSize: 13,
                          textTransform: "none",
                          borderRadius: "8px",
                          py: 0.9,
                          background: "#3b82f6",
                          color: "#ffffff",
                          "&:hover": {
                            background: "#2563eb",
                          },
                        }}
                        onClick={() => {
                          const isLoggedIn =
                            localStorage.getItem("logged_in") === "true";
                          if (isLoggedIn) {
                            const mentorId =
                              c.mentor_id || c.user_id || c._id || c.id;
                            if (mentorId) {
                              localStorage.setItem("mentor_id", mentorId);
                            }
                            window.open("/codegenie/visitcourse", "_blank");
                          } else {
                            setLoginPopup(true);
                          }
                        }}
                      >
                        View Course
                      </Button>
                    </Stack>
                  </Paper>
                </Grid>
              ))}
          </Grid>

          {/* Pagination */}
          <Stack direction="row" justifyContent="flex-end" mt={4}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(_, value) => setPage(value)}
              shape="rounded"
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  sx={{
                    width: 32,
                    height: 32,
                    minWidth: 32,
                    borderRadius: "6px",
                    fontFamily: interFont,
                    fontSize: 13,
                    color: "#d1d5db",
                    border: "1px solid #30363d",
                    backgroundColor: "#161b22",

                    "&.Mui-selected": {
                      backgroundColor: primary,
                      color: "#ffffff",
                      border: `1px solid ${primary}`,
                    },

                    "&:hover": {
                      backgroundColor: "rgba(59,130,246,0.1)",
                      borderColor: primaryLight,
                    },

                    "&.MuiPaginationItem-ellipsis": {
                      backgroundColor: "transparent",
                      border: "none",
                      color: "#6b7280",
                    },
                  }}
                />
              )}
            />
          </Stack>
        </Box>
      </Box>

      {/* Login Popup */}
      <Modal open={loginPopup} onClose={() => setLoginPopup(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "#161b22",
            borderRadius: "14px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
            p: 4,
            textAlign: "center",
          }}
        >
          {/* Blue accent bar at top */}
          <Box
            sx={{
              width: 48,
              height: 4,
              borderRadius: "2px",
              background: "#3b82f6",
              mx: "auto",
              mb: 2.5,
            }}
          />

          <Typography
            fontFamily={interFont}
            sx={{ color: "#e5e7eb", fontSize: "18px", fontWeight: 700, mb: 1 }}
          >
            Authentication Required
          </Typography>

          <Typography
            fontFamily={interFont}
            sx={{ color: "#9ca3af", fontSize: "14px", mb: 3.5 }}
          >
            Please sign in to view course details.
          </Typography>

          <Stack direction="row" spacing={1.5} justifyContent="center">
            <Button
              variant="outlined"
              onClick={() => setLoginPopup(false)}
              sx={{
                fontFamily: interFont,
                fontWeight: 600,
                fontSize: 13,
                textTransform: "none",
                borderRadius: "8px",
                color: "#9ca3af",
                borderColor: "#30363d",
                px: 2.5,
                "&:hover": { borderColor: "#4b5563", background: "#0d1117" },
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              disableElevation
              onClick={() => {
                setLoginPopup(false);
                localStorage.setItem("activeItem", "course");
                navigate("/signin");
              }}
              sx={{
                fontFamily: interFont,
                fontWeight: 600,
                fontSize: 13,
                textTransform: "none",
                borderRadius: "8px",
                px: 2.5,
                background: "#3b82f6",
                "&:hover": {
                  background: "#2563eb",
                },
              }}
            >
              Sign In
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}